/**
 * @desc: 风控执行
 * @created: 2020/5/18
 * @author: Colorfule
 * @version: v1.0
 */

import * as Models from '@/api/T3/riskControlExecute'

export default {
  namespaced: true,
  actions: {
    // 获取资料注册列表数据
    getListData(ctx, payload) {
      return Models.getListData(payload).then(res => {
        return (res && res.status === 200 && res.data) || {}
      })
    },

    // 收支比(图表)
    getIncomeExpensesRatio(ctx, payload) {
      return Models.getIncomeExpensesRatio(payload).then(res => {
        return (res && res.status === 200 && res.data) || []
      })
    },

    // 收支比(卡片数据)
    getIncomeExpensesStatistic(ctx, payload) {
      return Models.getIncomeExpensesStatistic(payload).then(res => {
        return (res && res.status === 200 && res.data) || []
      })
    },

    // 各项收支列表(表格数据)
    getIncomeExpensesList(ctx, payload) {
      return Models.getIncomeExpensesList(payload).then(res => {
        return (res && res.status === 200 && res.data) || []
      })
    },

    // 风控执行详情/关系链条
    getRiskExecuteTradeChain(ctx, payload) {
      return Models.getRiskExecuteTradeChain(payload).then(res => {
        return (res && res.status === 200 && res.data) || {}
      })
    },

    // 获取执行风控记录
    getRiskExecuteHistory(ctx, payload) {
      return Models.getRiskExecuteHistory(payload).then(res => {
        return (res && res.status === 200 && res.data) || []
        // return res && res.status === 200 && res.data
        return res
      })
    },

    // 添加风控执行
    postSaveNewRiskExecute(ctx, payload) {
      return Models.postSaveNewRiskExecute(payload).then(res => {
        return res && res.status === 200 ? 'success' : 'error'
      })
    }
  }
}
